
<script>
import simplebar from "simplebar-vue";

/**
 * Nav-bar Component
 */
export default {
  components: { simplebar },
  data() {
    return {
      fullname: "",
        agentApprovalCount: localStorage.getItem("agentApprovalCount") || 0,
        pendingDepositCount: localStorage.getItem("pendingDepositCount") || 0,
        eTicketCount: localStorage.getItem("eTicketCount") || 0,
        supportTicketCount: localStorage.getItem("supportTicketCount") || 0,
        bookingConfirmedCount: localStorage.getItem("bookingConfirmedCount") || 0,
        ticketingConfirmedCount: localStorage.getItem("ticketingConfirmedCount") || 0,
        totalNotificationCount: localStorage.getItem("totalNotificationCount") || 0,
        pendingPartialPaymentCount: localStorage.getItem("pendingPartialPaymentCount") || 0,
        searchFilter:"",
    };
  },
    watch: {
        searchFilter: function (value) {
            // console.log(value) // log it BEFORE model is changed
            // console.log("first");
            this.$emit('NavbarCustomEventInputChanged', this.searchFilter);
        }
    },
 created() {
    this.fullname = localStorage.getItem("full_name");
      const reload=localStorage.getItem("reloaded");
      if(reload=='false'){
          this.getAgentCount();
          this.pendingDepositCountFunc();
          this.eTicketCountFunc();
          this.supportTicketCountFunc();
          this.bookingConfirmedCountFunc();
          this.ticketingConfirmedCountFunc();
          this.pendingPartialPaymentCountFunc();
            localStorage.setItem("reloaded","true");
      }
  },
  methods: {
     totalCount(){
          const count = (key) => Number(localStorage.getItem(key)) || 0;
          this.totalNotificationCount = count("agentApprovalCount")
              + count("pendingDepositCount")
              + count("eTicketCount")
              + count("supportTicketCount")
              + count("bookingConfirmedCount")
              + count("ticketingConfirmedCount")
              + count("pendingPartialPaymentCount");
          localStorage.setItem("totalNotificationCount",this.totalNotificationCount.toString());
      },
     getAgentCount() {
          try {
              axios
                  .get("/api/agent-approval-count", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                        if(response.data.data==''){
                            this.agentApprovalCount=0;
                            localStorage.setItem("agentApprovalCount",this.agentApprovalCount);
                        }else{
                            this.agentApprovalCount=response.data.data;
                            localStorage.setItem("agentApprovalCount",this.agentApprovalCount);
                        }
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      pendingDepositCountFunc() {
          try {
              axios
                  .get("/api/pending-deposit-count", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          if(response.data.data==''){
                              this.pendingDepositCount=0;
                              localStorage.setItem("pendingDepositCount",0);
                          }else{
                              this.pendingDepositCount=response.data.data;
                              localStorage.setItem("pendingDepositCount",response.data.data);
                          }
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      eTicketCountFunc() {
          try {
              axios
                  .get("/api/e-ticket-count", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          if(response.data.data==''){
                              this.eTicketCount=0;
                              localStorage.setItem("eTicketCount",0);
                          }else{
                              this.eTicketCount=response.data.data;
                              localStorage.setItem("eTicketCount",response.data.data);
                          }
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      supportTicketCountFunc() {
          try {
              axios
                  .get("/api/support-ticket-count", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          if(response.data.data==''){
                              this.supportTicketCount=0;
                              localStorage.setItem("supportTicketCount",0);
                          }else{
                              this.supportTicketCount=response.data.data;
                              localStorage.setItem("supportTicketCount",response.data.data);
                          }
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      bookingConfirmedCountFunc() {
          try {
              axios
                  .get("/api/booking-confirmed-count", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          if(response.data.data==''){
                              this.bookingConfirmedCount=0;
                              localStorage.setItem("bookingConfirmedCount",0);
                          }else{
                              this.bookingConfirmedCount=response.data.data;
                              localStorage.setItem("bookingConfirmedCount",response.data.data);
                          }
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      ticketingConfirmedCountFunc() {
          try {
              axios
                  .get("/api/ticketing-confirmed-count", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                     if(response.data.data==''){
                         this.ticketingConfirmedCount=0;
                         localStorage.setItem("ticketingConfirmedCount",0);
                     }else{
                         this.ticketingConfirmedCount=response.data.data;
                         localStorage.setItem("ticketingConfirmedCount",response.data.data);
                     }
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      pendingPartialPaymentCountFunc() {
          try {
              axios
                  .get("/api/pending-partial-payment-count", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          if(response.data.data==''){
                              this.pendingPartialPaymentCount=0;
                              localStorage.setItem("pendingPartialPaymentCount",0);
                          }else{
                              this.pendingPartialPaymentCount=response.data.data;
                              localStorage.setItem("pendingPartialPaymentCount",response.data.data);
                          }
                          this.totalCount();
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      errorCheck(obj) {
          if (obj.error) {
              this.errors = obj.message;
          } else if (obj.message == "Token has expired") {
              this.$swal.fire({
                  title: 'LogOut!',
                  text: 'Token Has Expired',
                  icon: 'error',
                  toast:'true',
                  position: 'top-end',
              });
              this.$router.push({ name: "logout" });
          } else if (
              obj.message !== "Token has expired" &&
              obj.message !== "The given data was invalid."
          ) {
              this.errors = obj.message;
          } else if (obj.message == "The given data was invalid.") {
              this.errors = obj.errors;
          } else {
              this.flashMessage.show({
                  time: 5000,
                  status: "error",
                  title: "Error",
                  message: "Problem in data save",
              });
          }
      },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="/images/logo.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="/images/logo-dark.png" alt height="17" />
            </span>
          </a>

          <a href="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="/images/logo-light.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="/images/logo-light.png" alt height="19" style="width: 100%; height: 43px;" />
            </span>
          </a>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input type="text" v-model="searchFilter" class="form-control" placeholder="Search..." />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>
      </div>
            <div class="d-flex">

<!--                <template v-slot:button-content>-->
<!--                    <i class="bx bx-sad font-size-24"></i>-->
<!--                    <span class="badge badge-danger badge-pill">{{totalNotificationCount}}</span>-->
<!--                </template>-->

                    <router-link id="tooltip-button-agent-approval" class="text-reset notification-item" to="/agent/agent_list">

                        <div class="mini-stat-icon">
                            <i class="bx bx-sad font-size-24"></i><span class="badge badge-danger badge-pill  noti-icon-pos">{{agentApprovalCount}}</span>
                        </div>
                    </router-link>
                <b-tooltip target="tooltip-button-agent-approval" placement="bottom">Agent Approval List</b-tooltip>
                    <router-link id="tooltip-pending-deposit" class="text-reset notification-item" to="/deposit/deposit_list/pending">

                        <div class="mini-stat-icon">

                        <i class="bx bx-dollar font-size-24"></i><span class="badge badge-danger badge-pill noti-icon-pos">{{pendingDepositCount}}</span>

                        </div>
                    </router-link>
                <b-tooltip target="tooltip-pending-deposit" placement="bottom">Pending Deposit List</b-tooltip>
                <router-link id="tooltip-e-ticket-count" class="text-reset notification-item" to="/e_ticket/e_ticket_list">

                    <div class="mini-stat-icon">


                        <i class="bx bxs-file-blank font-size-24"></i><span class="badge badge-danger badge-pill noti-icon-pos">{{eTicketCount}}</span>

                    </div>
                </router-link>
                <b-tooltip target="tooltip-e-ticket-count" placement="bottom">E Ticket List</b-tooltip>
                <router-link id="tooltip-support-ticket" class="text-reset notification-item" to="/support_ticket/ticket_list">

                    <div class="mini-stat-icon">

                        <i class="bx bxs-envelope font-size-24"></i><span class="badge badge-danger badge-pill noti-icon-pos">{{supportTicketCount}}</span>

                    </div>
                </router-link>
                <b-tooltip target="tooltip-support-ticket" placement="bottom">Support Ticket List</b-tooltip>
                <router-link id="tooltip-confirmed-booking" class="text-reset notification-item" to="/booking/list/booking-confirmed">

                    <div class="mini-stat-icon">


                        <i class="bx bx-book font-size-24"></i><span class="badge badge-danger badge-pill noti-icon-pos" >{{bookingConfirmedCount}}</span>

                    </div>
                </router-link>
                <b-tooltip target="tooltip-confirmed-booking" placement="bottom">Confirmed Booking List</b-tooltip>
                <router-link id="tooltip-ticket-confirm" class="text-reset notification-item" to="/booking/list/ticket-confirmed">

                    <div class="mini-stat-icon">


                        <i class="bx bxs-plane-alt font-size-24"></i> <span class="badge badge-danger badge-pill noti-icon-pos">{{ticketingConfirmedCount}}</span>

                    </div>
                </router-link>
                <b-tooltip target="tooltip-ticket-confirm" placement="bottom">Confirmed Ticket List</b-tooltip>

                <router-link id="tooltip-partial-pending" class="text-reset notification-item" to="/booking/partial_payment_list/pending">

                    <div class="mini-stat-icon">


                        <i class="bx bx-detail font-size-24"></i> <span class="badge badge-danger badge-pill noti-icon-pos">{{pendingPartialPaymentCount}}</span>

                    </div>
                </router-link>
                <b-tooltip target="tooltip-partial-pending" placement="bottom">Pending Partial Payment Requests</b-tooltip>
                <div>

                </div>
            </div>
      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

<!--        <b-dropdown variant="black" right toggle-class="header-item">-->
<!--          <template v-slot:button-content>-->
<!--            <img class src="/images/flags/us.jpg" alt="Header Language" height="16" />-->
<!--          </template>-->

<!--          &lt;!&ndash; item&ndash;&gt;-->
<!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
<!--            <img src="/images/flags/spain.jpg" alt="user-image" class="mr-1" height="12" />-->
<!--            <span class="align-middle">Spanish</span>-->
<!--          </a>-->

<!--          &lt;!&ndash; item&ndash;&gt;-->
<!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
<!--            <img src="/images/flags/germany.jpg" alt="user-image" class="mr-1" height="12" />-->
<!--            <span class="align-middle">German</span>-->
<!--          </a>-->

<!--          &lt;!&ndash; item&ndash;&gt;-->
<!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
<!--            <img src="/images/flags/italy.jpg" alt="user-image" class="mr-1" height="12" />-->
<!--            <span class="align-middle">Italian</span>-->
<!--          </a>-->

<!--          &lt;!&ndash; item&ndash;&gt;-->
<!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
<!--            <img src="/images/flags/russia.jpg" alt="user-image" class="mr-1" height="12" />-->
<!--            <span class="align-middle">Russian</span>-->
<!--          </a>-->
<!--        </b-dropdown>-->

<!--        <b-dropdown-->
<!--          class="d-none d-lg-inline-block noti-icon"-->
<!--          menu-class="dropdown-menu-lg"-->
<!--          right-->
<!--          toggle-class="header-item"-->
<!--          variant="black"-->
<!--        >-->
<!--          <template v-slot:button-content>-->
<!--            <i class="bx bx-customize"></i>-->
<!--          </template>-->

<!--          <div class="px-lg-2">-->
<!--            <div class="row no-gutters">-->
<!--              <div class="col">-->
<!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
<!--                  <img src="/images/brands/github.png" alt="Github" />-->
<!--                  <span>GitHub</span>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div class="col">-->
<!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
<!--                  <img src="/images/brands/bitbucket.png" alt="bitbucket" />-->
<!--                  <span>Bitbucket</span>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div class="col">-->
<!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
<!--                  <img src="/images/brands/dribbble.png" alt="dribbble" />-->
<!--                  <span>Dribbble</span>-->
<!--                </a>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="row no-gutters">-->
<!--              <div class="col">-->
<!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
<!--                  <img src="/images/brands/dropbox.png" alt="dropbox" />-->
<!--                  <span>Dropbox</span>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div class="col">-->
<!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
<!--                  <img src="/images/brands/mail_chimp.png" alt="mail_chimp" />-->
<!--                  <span>Mail Chimp</span>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div class="col">-->
<!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
<!--                  <img src="/images/brands/slack.png" alt="slack" />-->
<!--                  <span>Slack</span>-->
<!--                </a>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </b-dropdown>-->

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button type="button" class="btn header-item noti-icon" @click="initFullScreen">
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge badge-danger badge-pill">{{totalNotificationCount}}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">Notifications</h6>
              </div>
              <div class="col-auto">
                <a href="#!" class="small">View All</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px;">
<!--            <a href="agent_list" class="text-reset notification-item">-->
                <router-link  class="text-reset notification-item" to="/agent/agent_list">
              <div class="media">
                <div class="avatar-xs mr-3">
<!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
                    <span class="badge badge-danger badge-pill">{{agentApprovalCount}}</span>
<!--                  </span>-->
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">Agent Approval List</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">Agents Waiting For Approval</p>
<!--                    <p class="mb-0">-->
<!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
<!--                    </p>-->
                  </div>
                </div>
              </div>
<!--            </a>-->
              </router-link>
              <router-link  class="text-reset notification-item" to="/deposit/deposit_list">
                  <div class="media">
                      <div class="avatar-xs mr-3">
                          <!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
                          <span class="badge badge-danger badge-pill">{{pendingDepositCount}}</span>
                          <!--                  </span>-->
                      </div>
                      <div class="media-body">
                          <h6 class="mt-0 mb-1">Pending Deposit List</h6>
                          <div class="font-size-12 text-muted">
                              <p class="mb-1">Deposit Waiting For Approval</p>
                              <!--                    <p class="mb-0">-->
                              <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
                              <!--                    </p>-->
                          </div>
                      </div>
                  </div>
                  <!--            </a>-->
              </router-link>
              <router-link  class="text-reset notification-item" to="/e_ticket/e_ticket_list">
                  <div class="media">
                      <div class="avatar-xs mr-3">
                          <!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
                          <span class="badge badge-danger badge-pill">{{eTicketCount}}</span>
                          <!--                  </span>-->
                      </div>
                      <div class="media-body">
                          <h6 class="mt-0 mb-1">E Ticket Request List</h6>
                          <div class="font-size-12 text-muted">
                              <p class="mb-1">Booking with E Ticket Processing Status</p>
                              <!--                    <p class="mb-0">-->
                              <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
                              <!--                    </p>-->
                          </div>
                      </div>
                  </div>
                  <!--            </a>-->
              </router-link>
              <router-link  class="text-reset notification-item" to="/support_ticket/ticket_list">
                  <div class="media">
                      <div class="avatar-xs mr-3">
                          <!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
                          <span class="badge badge-danger badge-pill">{{supportTicketCount}}</span>
                          <!--                  </span>-->
                      </div>
                      <div class="media-body">
                          <h6 class="mt-0 mb-1">Support Ticket Request List</h6>
                          <div class="font-size-12 text-muted">
                              <p class="mb-1">Support Ticket Request</p>
                              <!--                    <p class="mb-0">-->
                              <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
                              <!--                    </p>-->
                          </div>
                      </div>
                  </div>
                  <!--            </a>-->
              </router-link>
              <router-link  class="text-reset notification-item" to="/booking/list">
                  <div class="media">
                      <div class="avatar-xs mr-3">
                          <!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
                          <span class="badge badge-danger badge-pill">{{bookingConfirmedCount}}</span>
                          <!--                  </span>-->
                      </div>
                      <div class="media-body">
                          <h6 class="mt-0 mb-1">Booking Confirmed List</h6>
                          <div class="font-size-12 text-muted">
                              <p class="mb-1">Confirmed Booking</p>
                              <!--                    <p class="mb-0">-->
                              <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
                              <!--                    </p>-->
                          </div>
                      </div>
                  </div>
                  <!--            </a>-->
              </router-link>
              <router-link  class="text-reset notification-item" to="/booking/list">
                  <div class="media">
                      <div class="avatar-xs mr-3">
                          <!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
                          <span class="badge badge-danger badge-pill">{{ticketingConfirmedCount}}</span>
                          <!--                  </span>-->
                      </div>
                      <div class="media-body">
                          <h6 class="mt-0 mb-1">Ticketing Confirmed List</h6>
                          <div class="font-size-12 text-muted">
                              <p class="mb-1">Confirmed Ticket</p>
                              <!--                    <p class="mb-0">-->
                              <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
                              <!--                    </p>-->
                          </div>
                      </div>
                  </div>
                  <!--            </a>-->
              </router-link>
              <router-link  class="text-reset notification-item" to="/booking/partial_payment_list">
                  <div class="media">
                      <div class="avatar-xs mr-3">
                          <!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
                          <span class="badge badge-danger badge-pill">{{pendingPartialPaymentCount}}</span>
                          <!--                  </span>-->
                      </div>
                      <div class="media-body">
                          <h6 class="mt-0 mb-1">Partial Payment List</h6>
                          <div class="font-size-12 text-muted">
                              <p class="mb-1">Pending Partial Payment Requests</p>
                              <!--                    <p class="mb-0">-->
                              <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
                              <!--                    </p>-->
                          </div>
                      </div>
                  </div>
                  <!--            </a>-->
              </router-link>
<!--            <a href class="text-reset notification-item">-->
<!--              <div class="media">-->
<!--                <div class="avatar-xs mr-3">-->
<!--                  <span class="avatar-title bg-success rounded-circle font-size-16">-->
<!--                    <i class="bx bx-badge-check"></i>-->
<!--                  </span>-->
<!--                </div>-->
<!--                <div class="media-body">-->
<!--                  <h6 class="mt-0 mb-1">Your item is shipped</h6>-->
<!--                  <div class="font-size-12 text-muted">-->
<!--                    <p class="mb-1">If several languages coalesce the grammar</p>-->
<!--                    <p class="mb-0">-->
<!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
<!--                    </p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </a>-->

<!--            <a href class="text-reset notification-item">-->
<!--              <div class="media">-->
<!--                <img-->
<!--                  src="/images/users/avatar-4.jpg"-->
<!--                  class="mr-3 rounded-circle avatar-xs"-->
<!--                  alt="user-pic"-->
<!--                />-->
<!--                <div class="media-body">-->
<!--                  <h6 class="mt-0 mb-1">Salena Layfield</h6>-->
<!--                  <div class="font-size-12 text-muted">-->
<!--                    <p class="mb-1">As a skeptical Cambridge friend of mine occidental.</p>-->
<!--                    <p class="mb-0">-->
<!--                      <i class="mdi mdi-clock-outline"></i> 1 hours ago-->
<!--                    </p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </a>-->
          </simplebar>
          <div class="p-2 border-top">
            <a class="btn btn-sm btn-light btn-block text-center" href="javascript:void(0)">
              <i class="mdi mdi-arrow-down-circle mr-1"></i> Load More..
            </a>
          </div>
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="/images/avatar.png"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ml-1">{{fullname}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <a class="dropdown-item" href="/contacts/profile">
            <i class="bx bx-user font-size-16 align-middle mr-1"></i> Profile
          </a>
<!--          <a class="dropdown-item" href="javascript: void(0);">-->
<!--            <i class="bx bx-wallet font-size-16 align-middle mr-1"></i> My Wallet-->
<!--          </a>-->
<!--          <a class="dropdown-item d-block" href="javascript: void(0);">-->
<!--            <span class="badge badge-success float-right">11</span>-->
<!--            <i class="bx bx-wrench font-size-16 align-middle mr-1"></i> Settings-->
<!--          </a>-->
<!--          <a class="dropdown-item" href="javascript: void(0);">-->
<!--            <i class="bx bx-lock-open font-size-16 align-middle mr-1"></i> Lock screen-->
<!--          </a>-->
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="/#/logout">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Logout
          </a>
        </b-dropdown>

<!--        <div class="dropdown d-inline-block">-->
<!--          <button-->
<!--            type="button"-->
<!--            class="btn header-item noti-icon right-bar-toggle toggle-right"-->
<!--            @click="toggleRightSidebar"-->
<!--          >-->
<!--            <i class="bx bx-cog bx-spin toggle-right"></i>-->
<!--          </button>-->
<!--        </div>-->
      </div>
    </div>
  </header>
</template>
<style scoped>
.navbar-brand-box{
    background-color: white!important;
}
.avatar-title{
border: 1px solid beige;
}
.avatar-sm {
    height: 2rem;
    width: 3rem;
}
.noti-icon-pos{
    position: absolute;
    top: 12px;
}
.text-reset{
    width:55px!important;
}

</style>
